import { loadChargebee } from "chargebee-js";

export const chargebeePromise = loadChargebee({
    site: process.env.REACT_APP_CHARGEBEE_SITE!,
});
